// extracted by css-extract-rspack-plugin
export default {"isKeyboardDragging":"DragAndDropContainer-module__isKeyboardDragging__q96KmEj","container":"DragAndDropContainer-module__container__TgNpSA5"};